<template>
  <div class="chooseschool chooseschool1">
    <div class="main">
      <div class="search-box" style="background: #fff">
        <div :class="['current-city',{'on':showCity}]" @click="toggleCity">{{currentCity.city_name}}</div>
        <div class="box">
          <input id="tipinput" placeholder="搜索当前城市下的具体地址" v-model="tipinput" @input="getSuggestions()">
          <ul v-if="suggestionList.length">
            <li v-for="item in suggestionList" @click="setCitySearch(item)">{{ item.title }}</li>
          </ul>
          <span class="clearbtn" v-if=" tipinput!='' " @click="clearInput"></span>
        </div>
        <!--<div class="cancel-btn" @click="cancel">取消</div>-->
      </div>
      <div class="choose-city" v-show="showCity">
        <!--<div class="current-city">上海 <span>当前定位城市</span></div>-->
        <div class="city-list">
          <div id="cityList">
            <div class="city-box" v-for="item in cityList">
              <div class="title" :id="item.pinyin_index">{{item.pinyin_index}}</div>
              <ul>
                <li v-for="item2 in item.city_list" @click="chooseCity(item2.city_name,item2.city_id)">{{item2.city_name}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="pinyin">
          <div v-for="item in pinyinList" @click="choosePinyin(item)">{{item}}</div>
        </div>
      </div>
      <div v-show="!showCity">
        <div id="mapContainer" style="height: 5rem;margin-top: 0.88rem;"></div>
        <div class="search-result" v-if="poiList.length" style="padding: 0 0.26rem">
          <ul class="list">
            <li v-for="(item,index) in poiList" @click="saveInfo(item)">
              <a>
                <p :class="{'first': index==0}"><span v-if="index==0">[当前位置]</span><span>{{item.title}}</span></p>
                <p class="detail">{{item.address}}</p></a>
            </li>
          </ul>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
  var wx = require('weixin-js-sdk')
  import {actions} from '../store/actions'
  var mapLoader = require('../store/TXMap')
  // import { MessageBox,Indicator } from 'mint-ui'

  export default {
    data () {
      let self = this
      return {
        poiList: [
         //  {
         //    name: '腾飞大厦',
         //    address: '天钥桥路333'
         //  },
         // {
         //   name: '腾飞大厦',
         //   address: '天钥桥路333'
         // }
        ],
        message:'',
        pinyinList: [],
        cityList: [],
        showCity: false,
        currentCity: {
          city_name: '上海市',
          city_id: '181'
        },
        // searchOption: {
        //   city: '',
        //   citylimit: true
        // },
        map: null,
        mapCenter: [31.18839,121.44239], // 地图中心点位置
        markerGeo: null, // 标记
        mamarkerLayer: null,
        suggest: null, // 输入建议
        suggestionList: [],
        geocoder: null, // 地址解析

        addressInfo:{lon:0,lat:0,poi_address:''},
        tipinput:'',
        locationStatus:false
      }
    },
    created () {
      var _this = this;
      // document.title = "搜索地址";
      _this.addressInfo = JSON.parse(window.localStorage.getItem('addressInfo'));
      if(_this.addressInfo && _this.addressInfo.lat && _this.addressInfo.lon){
        _this.mapCenter = [_this.addressInfo.lat,_this.addressInfo.lon];
        _this.initMap();
      }else{
        var u = encodeURIComponent(window.location.href.split('#')[0]);
        actions.getJslbsConf(_this,u,function (data) {
          let newData = JSON.parse(data);
          wx.config({
            debug: false,
            appId: newData.appId,
            timestamp: newData.timestamp,
            nonceStr: newData.nonceStr,
            signature: newData.signature,
            jsApiList: newData.jsApiList
          })
          wx.ready(function () {
            _this.$indicator.open({
              text: '正在努力定位中'
            });
            wx.getLocation({
              type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: (res) => {
                if(res.latitude && res.longitude){
                  _this.mapCenter = [res.latitude,res.longitude];
                  _this.initMap();
                }
              },
              fail: (res) => {
                _this.$messagebox.alert('定位失败，请查看是否允许定位或者手动进行搜索')
                _this.initMap();
              }
            })
          })
        })
      }
      _this.postCityList();

    },
    methods: {
      initMap() {
        mapLoader().then((TXMap)=>{
          this.TXMap = TXMap;
          var center = new TXMap.LatLng(this.mapCenter[0],this.mapCenter[1]);
          this.map = new TXMap.Map(document.getElementById("mapContainer"), {
            // 配置地图参数
            center: center, //地图中心点 维度，经度
            zoom: 15,
            showControl: false
          });

          // 标记中心点
          this.markerGeo = {
            id: 'center',
            position: this.map.getCenter(),
          };

          // 创建一个位于地图中心点的marker
          this.markerLayer = new TXMap.MultiMarker({
            map: this.map,
            geometries: [
              this.markerGeo
            ]
          });

          // 新建一个正逆地址解析类
          this.geocoder = new TXMap.service.Geocoder();
          this.updateLocation(this.map.getCenter(),'init');
          // 新建一个关键字输入提示类
          this.suggest = new TXMap.service.Suggestion({
            pageSize: 10, // 返回结果每页条目数
          });
          // 监听中心点变化事件，更新marker的位置
          this.map.on('center_changed', () => {
            this.updateLocation(this.map.getCenter());
          });
          this.$indicator.close();
          // var search = new TXMap.service.Search({ pageSize: 10 }); // 新建一个地点搜索类
        })
      },
      // 输入建议
      getSuggestions() {
        this.suggestionList = [];
        if(this.tipinput.length && this.tipinput.length > 1) {
          this.suggest
          .getSuggestions({ keyword: this.tipinput, location: this.map.getCenter() })
          .then((result) => {
            if(result.data && result.data.length){
              this.suggestionList = result.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
        }
      },
      // 设置地图中心点标记，逆地址解析拿到poilist
      updateLocation(location,init) {
        if(!init){
          this.markerLayer.setGeometries([]);
          this.markerGeo.position = location;
          this.markerLayer.updateGeometries([this.markerGeo]);
          this.map.setCenter(location);
        }
        this.geocoder
          .getAddress({ location: location, get_poi: 1, pageSize: 10, policy: 2 }) // 将给定的坐标位置转换为地址
          .then((result) => {
            if(result.result && result.result.pois){
              this.poiList = result.result.pois;
              // this.tipinput = '';
            }
            if(init && result.result.address_component && result.result.address_component.city){
              this.currentCity = { city_name: result.result.address_component.city};
            }
          })
      },
      // 关键字搜索
      setCitySearch(item){
        this.suggestionList = [];
        this.tipinput = item.title;
        this.updateLocation(item.location);
      },
      saveInfo: function (item) {
        var _this = this
        _this.addressInfo.lon = item.location.lng;
        _this.addressInfo.lat = item.location.lat;
        _this.addressInfo.poi_address = item.title;
        window.localStorage.setItem('addressInfo', JSON.stringify(_this.addressInfo));
        _this.$router.go(-1);

      },
      postCityList: function () {
        var _this = this
        actions.postCityList(_this, {}, function (data) {
          var pinyinList = [] //取出所有拼音列表
          for(var i=0;i<data.length;i++) {
            if(pinyinList.indexOf(data[i].pinyin_index)<0) {
              pinyinList.push(data[i].pinyin_index)
            }
          }
          _this.pinyinList = pinyinList

          var cityList = []

          for(var i=0;i<_this.pinyinList.length;i++) {

            var categoryObj = {}
            var city_list = []
            for(var m=0;m<data.length;m++) {
              var obj = {}
              if(data[m].pinyin_index === _this.pinyinList[i]) {
                obj.city_name = data[m].city_name
                obj.city_id = data[m].city_id
                obj.pinyin = data[m].pinyin
                city_list.push(obj)
              }
            }

            categoryObj.pinyin_index = _this.pinyinList[i]
            categoryObj.city_list = city_list
            cityList.push(categoryObj)
          }
          _this.cityList = cityList

        })
      },
      // 选择城市
      chooseCity: function (name,id) {
        this.poiList = []
        var currentCity = {
          city_name: name,
          city_id: id
        }
        this.currentCity = currentCity;
        // this.searchOption.city = this.currentCity.city_name;
        this.tipinput = ''
        this.geocoder
          .getLocation({ address: name })
          .then((result) => {
            if(result.result && result.result.location){
              this.updateLocation(result.result.location);
              this.toggleCity();
            }
          })
      },
      // mapMoveend: function (e) {
      //   let _this = this
      //   console.log(e,'99')
      //   var map = new AMap.Map("mapContainer", {
      //     resizeEnable: true,
      //     center: _this.mapCenter,
      //     zoom: 15
      //   })
      //   _this.mapCenter = map.getCenter();
      //   console.log(map.getCenter())
      //   // console.log(map.getCenter())
      //
      // },
      toggleCity: function () {
        this.showCity = !this.showCity
      },
      // 选择拼音
      choosePinyin: function (tagCode) {
        var dd = document.getElementById(tagCode).offsetTop;
        document.getElementById('cityList').style.transition = "-webkit-transform 500ms";
        if(dd>0) {
          document.getElementById('cityList').style.webkitTransform = "translate(0,-"+(dd)+"px)"
        } else {
          document.getElementById('cityList').style.webkitTransform = "translate(0,"+dd+"px)"
        }
      },
      searchSchool:function () {
        var _this = this
        var params = {keyword:_this.message}
        actions.postSearchSchool(_this, params, function (data) {
          if (data.length > 0) {
            _this.schoolList = data
          }
        })
      },
      clearInput: function (){
        this.tipinput = ''
      },

    },
  }
</script>
<style scoped>
.search-box{
  z-index: 10000;
}
.search-box .box{
  position: relative;
}
.search-box .box ul{
  position: absolute;
  left: 0;
  right: 0;
  top: .6rem;
  background-color: #fff;
}
.search-box .box ul li{
  padding: .1rem;
}
</style>



// WEBPACK FOOTER //
// ChooseAddress.vue?00638f66